import React from 'react';
import { BenefitSlide } from '../../../types/content';
import './Slide.scss';
import Image from '../../UI/Image/Image';
import PictureImage from '../../UI/Image/Picture';

interface ISlideProps {
  slide: BenefitSlide;
  index: number;
}

const Slide = ({ slide, index }: ISlideProps) => {
  const images = [
    {
      imageName: slide.image + '_desktop',
      minWidth: 1081
    },
    {
      imageName: slide.image + '_tablet',
      minWidth: 661
    },
    {
      imageName: slide.image + '_mobile',
      minWidth: 0
    }
  ];


  return (
    <div className="advantages_slider_slide">
      <div className="advantages_slider_slide_background">
        <PictureImage
          images={images}
          extension="jpg"
          altText={slide.title}
          className={(index === 0)?["firstSlide"]: [""]}
        />
      </div>
      <div className="advantages_slider_slide_content">
        <div
          className={`advantages_slider_slide_content_inner${
            slide.logo ? ' with-logo' : ''
          }`}
        >
          {slide.logo && (
            <Image
              imageName={slide.logo}
              altText={slide.title}
              extension="png"
              className={["lazyload"]}
            />
          )}
          <h2 className="">{slide.title}</h2>
          <h3>{slide.description}</h3>
        </div>
      </div>
    </div>
  );
};

export default Slide;
